// Convierte cualquier fecha guardada al formato 'YYYY-MM-DD' que necesitan los
// campos <input type="date">. Devuelve '' si no hay fecha, para que el campo
// aparezca vacío en vez de con una fecha inventada.
export function fechaParaInput(valor) {
  if (!valor) return '';

  const texto = String(valor);
  if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return texto;

  const fecha = new Date(texto);
  if (isNaN(fecha.getTime())) return '';

  // Se usa la fecha local, no la UTC, para no retroceder un día.
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  return `${fecha.getFullYear()}-${mes}-${dia}`;
}

// Formatea una fecha para mostrarla al usuario.
//
// JavaScript interpreta las cadenas 'YYYY-MM-DD' como UTC. Al mostrarlas en un
// huso negativo —Colombia es UTC-5— la fecha retrocede un día: un préstamo
// creado el 28 aparecía como 27. Añadiendo la hora se lee como medianoche
// local y la fecha mostrada coincide con la elegida.
//
// Las marcas de tiempo completas (con hora o zona) ya no tienen ese problema,
// así que se pasan tal cual.
export function formatearFecha(valor) {
  if (!valor) return '-';

  const texto = String(valor);
  const soloFecha = /^\d{4}-\d{2}-\d{2}$/.test(texto);
  const fecha = new Date(soloFecha ? `${texto}T00:00:00` : texto);

  return isNaN(fecha.getTime()) ? '-' : fecha.toLocaleDateString('es-CO');
}
